import Link from "next/link";
import type { MenuItemT } from "@/app/constants/menu-items";
import { MENU_ITEMS } from "@/app/constants/menu-items";

/**
 * Renders a navigation item and its children recursively
 */
function renderMenuItem(item: MenuItemT, index: number) {
  return (
    <li key={`${item.href}-${index}`} className="navbar-item">
      <Link href={item.href} className="navbar-link" tabIndex={-1}>
        {item.title}
      </Link>
      {item.children && item.children.length > 0 && (
        <ul className="navbar-dropdown">
          {item.children.map((child, childIndex) =>
            renderMenuItem(child, childIndex)
          )}
        </ul>
      )}
    </li>
  );
}

/**
 * Server Component that renders all navigation links
 * This ensures search engines can crawl all links even if the nav menu
 * is controlled by client-side JavaScript
 */
type StaticNavLinksProps = {
  menuItems?: MenuItemT[];
};

export default function StaticNavLinks({
  menuItems = MENU_ITEMS,
}: StaticNavLinksProps) {
  return (
    <div className="sr-only">
      <ul className="navbar-items">
        {menuItems.map((item, index) => renderMenuItem(item, index))}
      </ul>
    </div>
  );
}
